import { apiClient } from "@/api";

export const nonFalsyEntries = (obj) => {
  if (!obj || typeof obj !== "object") {
    throw new Error("nonFalsyEntries: obj must be an object");
  }
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const isInt = (value) => {
  return Number.isInteger(value);
};

/**
 * Unpaginate API request to get all pages of results.
 * @param {AxiosRequestConfig<T>} config
 * @returns {AxiosPromise<T[]>}
 */
export const unPaginateApiRequest = async (config) => {
  if (!config) return;
  const limit = config.params?.limit || 100;
  let offset = 0;
  let totalCount = 0;
  let result = [];

  if (!config.params || !config.params.limit) {
    config.params = {
      ...config.params,
      limit,
      offset,
    };
  }
  config.params.offset = 0;
  const { data } = await apiClient(config);
  totalCount = data.count ?? 0;
  if (totalCount <= limit) {
    /**
     * If the total count is less than or equal to the limit,
     */
    result = data.results || [];
    return result;
  }

  const chunksCount = Math.ceil(totalCount / limit);
  /**
   * Если размер чанков === 1 и меньше, то результаты уже можно считать
   * запрошенными
   */
  if (chunksCount < 2) {
    return result;
  }

  for (let i = 1; i < chunksCount; i++) {
    const { data } = await apiClient({
      ...config,
      params: {
        ...config.params,
        offset: limit * i,
      },
    });
    result = result.concat(data.results || []);
  }
  return result;
};

/**
 * Округляет число в большую сторону до ближайшего
 * целого кратного указанному значению точности.
 * @param {Number} value - значение
 * @param {Number} accuracy - значение точности например 0.1
 * @returns {Number} - с двумя числами после запятой
 */
export function ceiling(value, accuracy = 0.1, floats = 2) {
  if (value === 0 || typeof value !== "number") return 0;
  const v = Math.ceil(value / accuracy) * accuracy;
  return Number(v.toFixed(floats));
}

export const isFloat = (n) => {
  return typeof n === "number" && !isInt(n);
};

/**
 * Возвращает правильный падеж для числительного
 * @param {string[]} titles - массив строк [ключ, ключа, ключей] lenght = 3
 * @param {number} num - число
 * @return string
 */
export const numCases = (titles, num) => {
  // если число - не целое то вернем сразу 2 ключ, так как
  // дробное число родительный падеж (-десятых, -сотых, -тысячных).
  if (isFloat(num)) return titles[1];

  // Эта часть просто спизжена от куда-то =)
  const cases = [2, 0, 1, 1, 1, 2];
  const val = Math.abs(num);
  const current =
    val % 100 > 4 && val % 100 < 20 ? 2 : cases[val % 10 < 5 ? val % 10 : 5];
  return titles[current];
};
